/* eslint-disable no-console */
import * as GallerySlider from './gallery-slider';
import * as PreviewArea from './preview-area';
import { addPhotosModal, updatePhotosModal } from './photos-modal';

const miniGallery = () => {
  const slider = document.querySelector('.gallery-slider');
  if (!slider) {
    return;
  }

  const getGalleryItemData = () => {
    const arr = [];
    let srcStr = '';
    const galleryItems = slider.querySelectorAll('.image-gallery-item > button, .image-gallery-item > div');
    for (let i = 0; i < galleryItems.length; i++) { /* eslint-disable-line no-plusplus */
      const item = galleryItems[i];
      const img = item.querySelector('img');
      let src = '';
      let alt = '';
      if (img) {
        src = img.getAttribute('src');
        alt = img.getAttribute('alt');
      } else {
        src = item.getAttribute('data-imgsrc');
        alt = item.getAttribute('data-imgalt');
      }
      const notDupe = srcStr.indexOf(src) === -1;
      // Dedupe slider array
      if (item.getAttribute('data-type') === 'image' && notDupe) {
        arr.push({
          alt,
          caption: item.getAttribute('data-caption'),
          src,
          type: 'image',
        });
        srcStr = srcStr.concat(`,${src}`);
      } else if (item.getAttribute('data-type') === 'video' && notDupe) {
        arr.push({
          alt,
          caption: item.getAttribute('data-caption'),
          videosrc: item.getAttribute('data-videosrc'),
          src,
          type: 'video',
        });
        srcStr = srcStr.concat(`,${src}`);
      }
    }
    return arr;
  };

  GallerySlider.init({
    onSlideClick: (item) => {
      PreviewArea.update({ item });
      updatePhotosModal({
        photos: {
          primaryImage: PreviewArea.getPreviewData(),
          additionalImages: getGalleryItemData(),
        },
      });
    },
    slider,
  });
  addPhotosModal();
};

export default miniGallery;
/* eslint-enable no-console */
